import { createReducer } from 'redux-act';
import * as actions from '#app/actions/transferTrades';

interface TransferTradesState {
  modalVisible: boolean;
  form: Record<string, unknown>;
  notificationIds: unknown[];
  fieldsLockedByNotification: boolean;
}

const initialState: TransferTradesState = {
  modalVisible: false,
  form: {},
  notificationIds: [],
  fieldsLockedByNotification: false,
};

const setTransferTradesModalVisible = (
  state: TransferTradesState,
  bool: boolean
): TransferTradesState => ({
  ...state,
  modalVisible: bool,
});

const setTransferTradesForm = (
  state: TransferTradesState,
  form: Record<string, unknown> | null | undefined
): TransferTradesState => ({
  ...state,
  form: form || {},
  modalVisible: true,
  fieldsLockedByNotification: false,
});

const closeTransferTradesForm = (state: TransferTradesState): TransferTradesState => ({
  ...state,
  form: {},
  modalVisible: false,
  notificationIds: [],
  fieldsLockedByNotification: false,
});

const setTransferTradesNotificationIds = (
  state: TransferTradesState,
  ids: unknown[]
): TransferTradesState => ({
  ...state,
  notificationIds: ids,
});

const setTransferTradesFieldsLockedByNotification = (
  state: TransferTradesState,
  value: unknown
): TransferTradesState => ({
  ...state,
  fieldsLockedByNotification: !!value,
});

export default createReducer<TransferTradesState>(
  {
    [actions.setTransferTradesModalVisible as any]: setTransferTradesModalVisible,
    [actions.setTransferTradesForm as any]: setTransferTradesForm,
    [actions.closeTransferTradesForm as any]: closeTransferTradesForm,
    [actions.setTransferTradesNotificationIds as any]: setTransferTradesNotificationIds,
    [actions.setTransferTradesFieldsLockedByNotification as any]:
      setTransferTradesFieldsLockedByNotification,
  },
  initialState
);
